<script setup lang="ts">
import TemplateButton from '~/components/shared/button/TemplateButton.vue';
import Text from '~/components/shared/Text.vue';
import IconButton from '~/components/shared/Icon.vue';

import type { EIcon } from '~/enums/EIcon';
import Icon from '~/components/shared/Icon.vue';

interface Props {
  url?: string | null;
  target?: string;
  disabled?: boolean;
  secondary?: boolean;
  xs?: boolean;
  rightIcon?: EIcon.TImageKey;
  leftIcon?: EIcon.TImageKey;
  fullWidth?: boolean;
  mobFullWidth?: boolean;
  noPadding?: boolean;
  type?: 'button' | 'submit' | 'reset';
  white?: boolean;
  loading?: boolean;
}

interface Slots {
  default: any;
}

const props = withDefaults(defineProps<Props>(), { url: null, target: '_self', type: 'submit' });
const slots = defineSlots<Slots>();

const sizeIcon = 24;

const classes = computed(() => ({
  'button-site_full-width': props.fullWidth,
  'button-site_mob-full-width': props.mobFullWidth,
  'button-site_nopadding': props.noPadding,
}));

const templateBind = computed(() => {
  return {
    url: props.url,
    target: props.target,
    disabled: props.disabled,
    loading: props.loading,
    secondary: props.secondary,
    xs: props.xs,
    type: props.type,
  };
});
</script>

<template>
  <TemplateButton
    class="button-site"
    v-bind="templateBind"
    :class="classes"
  >
    <div v-if="leftIcon" class="button-site__left">
      <IconButton :icon="leftIcon" :size="sizeIcon"></IconButton>
    </div>

    <Icon v-if="loading" icon="MiscSpinner"/>

    <span
      v-else
      class="button-site__text"
    >
      <slot v-if="slots.default"/>
    </span>

    <div v-if="rightIcon" class="button-site__right">
      <IconButton :icon="rightIcon" :size="sizeIcon" :white="props.white"></IconButton>
    </div>
  </TemplateButton>
</template>

<style scoped lang="scss">
.button-site {
  gap: 0;
  outline: none;

  &__text {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    text-transform: uppercase;
    white-space: nowrap;
    padding: 0 8px;
  }

  &__right {
    display: flex;
    align-items: center;
  }

  &_full-width {
    width: 100%;
    max-width: 100%;
  }

  &_mob-full-width {
    @media ($media-mobile) {
      width: 100%;
      max-width: 100%;
    }
  }

  &_nopadding {
    padding: 0;
  }
}
</style>
